import { HTTP_METHODS } from '../../constants/HttpConstants';
import {
  sendRequestToDoloresService,
  sendRequestToDoSelectCentralService,
} from '../../utils/request';
import { IAiInterviewQueryParams } from '../../types/Interviews/aiInterview.types';

export const getAiInterviewsApi = async (params: IAiInterviewQueryParams) => {
  const response = await sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: '/search/psearch',
    params: {
      index: 'test',
      order_by: '-created',
      narrow:
        'category|PRI||test_type|GEN||mode|TIM||archived|false||sub_test_type|INT',
      ...params,
    },
  });
  return response;
};

export const getAnalyticsApi = async () => {
  const response = await sendRequestToDoloresService({
    method: HTTP_METHODS.GET,
    url: '/interview-ai/dashboard/analytics',
  });
  return response;
};
